import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ShieldCheck, Zap, CheckCircle2 } from "lucide-react";
import ExportGif from "../../assets/gif/exportgif.mp4";

export const HeroSection = () => {
  return (
    <section id="hero" className="relative overflow-hidden bg-gradient-to-b from-amber-50/40 via-white to-slate-50 text-slate-900 py-20 lg:py-28 border-b border-amber-100">
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-12 lg:gap-16">
          
          {/* Left Text Column */}
          <div className="flex-1 text-center lg:text-left space-y-6">
            <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-amber-100 border border-amber-200 text-amber-800 text-xs font-bold tracking-wide uppercase">
              <Zap className="w-4 h-4 text-amber-600" />
              <span>Next-Gen Enterprise Trade Platform</span>
            </div>

            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-slate-900 tracking-tight leading-[1.15]">
              Automate Global Trade & Ceramic Export Documentation{" "}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-600 via-amber-700 to-amber-800">
                In Minutes
              </span>
            </h1>

            <p className="text-base sm:text-lg text-slate-600 max-w-2xl mx-auto lg:mx-0 leading-relaxed font-normal">
              Unified export workflow platform engineered for ceramic tile manufacturers, global traders, and freight logistics handlers. Effortlessly manage quotations, proforma invoices, container packing lists, and inventory metrics in one high-density dashboard.
            </p>

            {/* CTA Group */}
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4 pt-2">
              <Link
                to="/signup"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2.5 px-8 py-3.5 rounded-xl bg-amber-600 hover:bg-amber-700 text-white font-bold text-sm shadow-lg shadow-amber-600/20 transition-all hover:scale-105 active:scale-95 cursor-pointer"
              >
                <span>Start Free Trial</span>
                <ArrowRight className="w-4 h-4" />
              </Link>
              <Link
                to="/login"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-xl bg-white hover:bg-slate-50 border border-slate-300 text-slate-800 font-bold text-sm transition-colors shadow-xs"
              >
                <span>Existing Customer Sign In</span>
              </Link>
            </div>

            {/* Feature Pills */}
            <div className="pt-6 flex flex-wrap items-center justify-center lg:justify-start gap-6 text-xs text-slate-600 font-semibold">
              <span className="flex items-center gap-1.5">
                <CheckCircle2 className="w-4 h-4 text-amber-600" /> Automated Incoterms Calculation
              </span>
              <span className="flex items-center gap-1.5">
                <CheckCircle2 className="w-4 h-4 text-amber-600" /> Multi-Currency Support
              </span>
              <span className="flex items-center gap-1.5">
                <CheckCircle2 className="w-4 h-4 text-amber-600" /> Audit Log & Version History
              </span>
            </div>
          </div>

          {/* Right Video / Animation Box */}
          <div className="flex-1 flex justify-center w-full">
            <div className="relative rounded-3xl bg-white border border-amber-200/80 p-3 shadow-xl w-full max-w-lg">
              <div className="rounded-2xl overflow-hidden border border-slate-200 bg-slate-50">
                <video
                  src={ExportGif}
                  alt="Export Stuff Trade Automation Preview"
                  className="w-full h-auto object-cover"
                  autoPlay
                  loop
                  muted
                  playsInline
                />
              </div>
              <div className="absolute -bottom-4 -left-4 bg-white border border-amber-200 p-3.5 rounded-2xl shadow-xl flex items-center gap-3 hidden sm:flex">
                <div className="p-2 rounded-xl bg-amber-100 text-amber-800 border border-amber-200">
                  <ShieldCheck className="h-5 w-5" />
                </div>
                <div>
                  <p className="text-xs font-bold text-slate-900">100% Compliant</p>
                  <p className="text-[11px] text-slate-500 font-medium">Customs & Shipping Advice Ready</p>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default HeroSection;
